"use strict";

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/es.array.for-each.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.get-own-property-descriptors.js");

require("core-js/modules/es.object.define-properties.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;

require("core-js/modules/es.object.define-property.js");

var _core = require("../core");

var _utils = require("../utils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var disabledStyles = function disabledStyles(theme) {
  return {
    '&$disabled': {
      '& $thumb': {
        color: theme.palette.grey[100],
        border: "1px solid ".concat(theme.palette.grey[400]),
        boxShadow: 'none'
      },
      '& + $track': {
        backgroundColor: theme.palette.grey[400],
        opacity: 1
      }
    }
  };
};

var useStyles = (0, _utils.createStylesHook)()(function (theme) {
  return {
    thumb: {},
    track: {
      backgroundColor: theme.palette.grey[600],
      opacity: 1
    },
    disabled: {},
    checked: {},
    colorPrimary: _objectSpread({
      '&$checked': _objectSpread({
        '& + $track': {
          backgroundColor: theme.palette.primary.alt,
          opacity: 1
        }
      }, disabledStyles(theme))
    }, disabledStyles(theme)),
    colorSecondary: _objectSpread({}, disabledStyles(theme))
  };
}, {
  name: (0, _core.rochePrefix)('Switch')
});
exports.useStyles = useStyles;